/* 利用方法区分 */
export default {
    // 会員証クーポン提示
    MEMBERSHIP_COUPON: "21",
    // 加盟店へ直接申込
    APPLY_DIRECTLY_TO_MEMBER_STORE: "30",
    // ベネ申込・Web受け不可
    NOT_AVAILABLE_WEB: "31",
    // ベネ申込・加盟店手配
    APPLY_WITH_MEMBER_STORE: "40",
    // 紙チケット
    PAPER_TICKET: "41",
    // ベネ申込・ベネ手配
    BENEFITS: "42",
    // テキスト案内
    TEXT_GUIDANCE: "50",
    // コンビニ端末申込
    CONVENIENCE_STORE_TERMINAL: "55",
    // デジタルクーポン
    DIGITAL_COUPON: "60",
    // デジタルチケット
    DIGITAL_TICKET: "65",
    // ポイント交換
    POINT_REDEMPTION: "70"
}